import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './applicationForm.css'
import logoSB from '../../../../../assets/img/logo-colores-originales-sin-bajada.png'
import { fetchEnrolment, fetchAppProfessions } from '../applicationControler'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { formatDataforGenericSelect } from '../../../../../helpers/formatGenericSelect'
import { GenericSelect } from '../../../../common/GenericSelect/GenericSelect'
import { useAppSubmitForm } from '../applicationControler'
import { GenericInput } from '../../../../common/GenericInput/GenericInput'
import { useRedirect } from '../../../../../hooks/useRedirect'
import { FormErrorMessage } from '../../../../feedback/apiResponse/FormErrorMessage'

export const ApplicationForm = () => {


    // const [enrolmentData, setEnrollmentData] = useState(null)
    const { enrollmentId } = useParams();
    const [professionsData, setProfessionsData] = useState(null)
    const [selectedOption, setSelectedOption] = useState("SameAddress")


    const { register, handleSubmit, onSubmit, setValue, message, errors, response } = useAppSubmitForm(enrollmentId, selectedOption)

    useEffect(() => {
        document.title = "TPA® Oficial - Formulario de inscripción"
    }, [])

    const [newArray, setNewArray] = useState([])
    const [sendKit, setSendKit] = useState(false)
    const [userState, setUserState] = useState(null)

    //console.log('userState: ', userState)
    useEffect(() => {
        const aplicationData = async () => {
            try {
                const data = await fetchEnrolment(enrollmentId)
                //console.log('enrolmentData: ', data)

                if (data) {
                    setUserState(data.enrollment.state)
                    // setUserState('')
                    setSendKit(data.sendKit)
                    setNewArray(prevArray => [...prevArray, data.profession])
                    //console.log('newArray: ', newArray)
                }
                // if (data.profession) {
                //     setEnrollmentData(data.profession)
                // }
            } catch (error) {
                console.error(error)
            }
        };
        aplicationData()
    }, [enrollmentId])


    useEffect(() => {

        const getProfessions = async () => {
            try {
                const data = await fetchAppProfessions()
                //console.log('fetchAppProfessions: ', data)

                if (data) {
                    setProfessionsData(data)
                }
            } catch (error) {
                console.error(error);
                throw error;
            }
        }

        getProfessions()
    }, [])




    const [selectedValue, setSelectedValue] = useState(null);
    const handleSelectChange = (selectedOption) => {
        setSelectedValue(selectedOption)

    }

    //? cambio de input


    const handleChange = (event) => {
        //console.log('event: ', event.target)
        setSelectedOption(event.target.value);
    };

    //console.log('selectedOptions: ', selectedOption)

    //? Redireccion mensaje de exito

    const { redirectTo } = useRedirect()

    useEffect(() => {
        if (response) {

            redirectTo('/completed-form', response, {
                message: `${message}`,
                title: "¡Éxito!"
            });
        }
    }, [response, redirectTo, message]);


    //? textarea 

    const [text, setText] = useState("")
    //console.log('text: ', text)

    return (
        <main className='applicationForm-main'>

            {/* hasta que userState no tenga un valor distinto de null, no se mostrara ningun componente */}
            {userState === null
                ?
                null
                :
                userState === 'Interested'
                    ?

                    <div className="form-container-inscripcion">
                        <form className="form-inscripcion" onSubmit={handleSubmit(onSubmit)}>


                            <Link className="back" to="/login"><i className="bi bi-arrow-left bi-class-back
                    "></i>Volver</Link>

                            <div className="logo-inscripcion">
                                <img src={logoSB} alt="logo" />
                            </div>

                            <h1 className="title-inscription">Formulario de Inscripción</h1>

                            <p className="intro">Hola futuro/a diplomado/a TPA®! ¡Gracias por brindarte y brindarnos la oportunidad de
                                continuar agrandando esta gran familia!
                                Completa el siguiente formulario con tus datos personales para avanzar en el proceso de Inscripción.
                            </p>





                            <div className="datos-container">
                                <span className="address-title-inscription">
                                    Domicilio
                                </span>

                                <div className="form-floating mb-3 mb3-input">


                                    <GenericInput
                                        required={true}
                                        name="streetAddress"
                                        register={register}
                                        errors={errors}
                                        label="Calle y Número "
                                        placeholder="Calle y Número"
                                    />

                                </div>

                                <div className="form-floating mb-3 mb3-input">


                                    <GenericInput
                                        required={true}
                                        name="addressAdditionalData"
                                        register={register}
                                        errors={errors}
                                        label="Información Adicional (Barrio, Piso, Dpto. etc.)"
                                        placeholder="Información Adicional (Barrio, Piso, Dpto. etc.)"
                                    />
                                </div>


                                <div className="location-cp">

                                    <div className="form-floating mb-3 mb3-input">

                                        <GenericInput
                                            required={true}
                                            name="addressCity"
                                            register={register}
                                            errors={errors}
                                            label="Localidad"
                                            placeholder="Localidad"
                                        />
                                    </div>



                                    <div className="form-floating mb-3 mb3-input">


                                        <GenericInput
                                            required={true}
                                            name="addressZipCode"
                                            register={register}
                                            errors={errors}
                                            label="Código Postal"
                                            placeholder="Código Postal"
                                        />
                                    </div>

                                </div>

                                <div className="form-floating mb-3 mb3-input">


                                    <GenericInput
                                        required={true}
                                        name="addressProvince"
                                        register={register}
                                        errors={errors}
                                        label="Provincia"
                                        placeholder="Provincia"
                                    />
                                </div>
                            </div>



                            {sendKit ? <>
                                <span className="kit-tpa">
                                    Envío del Kit TPA
                                </span>




                                <div className="container mt-4 mt-4-another container-pr-pl-mr-ml">

                                    <p className="kit-tpa-send">
                                        Dirección donde te gustaría recibir el KIT TPA® luego de la inscripción
                                    </p>

                                    <div className="form-check form-check-text">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="kitAddressType"
                                            id="SameAddress"
                                            value="SameAddress"
                                            checked={selectedOption === "SameAddress"}
                                            onChange={handleChange}
                                        // {...register("kitAddressType")}
                                        />
                                        <label className="form-check-label" htmlFor="SameAddress">
                                            MISMA DIRECCIÓN mencionada anteriormente
                                        </label>
                                    </div>


                                    <div className="form-check form-check-text">
                                        <input className="form-check-input"
                                            type="radio"
                                            name="kitAddressType"
                                            id="PickUp"
                                            value="PickUp"
                                            checked={selectedOption === "PickUp"}
                                            onChange={handleChange}
                                        // {...register("kitAddressType")}
                                        />
                                        <label className="form-check-label " htmlFor="PickUp">
                                            Retiro por Instituto Vianett® en Córdoba Capital
                                        </label>
                                    </div>

                                    {/* <!-- Informacion de ubicacion y horario en caso de Retiro por la Institucion --> */}


                                    {selectedOption === "PickUp" ? <div className="Institution-info">
                                        📍 Cosquín 1222, X5000 Córdoba
                                        🕒 Horario: Lunes a Viernes 8 a.m. - 12 p.m., 5 p.m. - 9 p.m.
                                    </div> : null}

                                    <div className="form-check form-check-text-otro">
                                        <input className="form-check-input"
                                            type="radio"
                                            name="kitAddressType"
                                            id="OtherAddress"
                                            value="OtherAddress"
                                            checked={selectedOption === "OtherAddress"}
                                            onChange={handleChange}
                                        // {...register("kitAddressType")}
                                        />

                                        <label className="form-check-label " htmlFor="OtherAddress">
                                            Otro Domicilio
                                        </label>
                                    </div>
                                </div>



                                {/* 
                <!-- Segunda direccion en caso de elegir "otro" --> */}
                                {selectedOption === "OtherAddress" ?
                                    <div className="other-address">
                                        <span className="span-alter-address d-flex">
                                            Domicilio Alternativo
                                        </span>

                                        <div className="form-floating mb-3-inscription">

                                            <GenericInput
                                                required={selectedOption === "option3"}
                                                name="alternativeStreetAddress"
                                                register={register}
                                                errors={errors}
                                                label="Calle y Número "
                                                placeholder="Calle y Número "

                                            />

                                        </div>

                                        <div className="form-floating mb-3-inscription">

                                            <GenericInput
                                                required={selectedOption === "option3"}
                                                name="alternativeAddressAdditionalData"
                                                register={register}
                                                errors={errors}
                                                label="Información Adicional (Barrio, Piso, Dpto. etc.)"
                                                placeholder="Información Adicional (Barrio, Piso, Dpto. etc.)"

                                            />
                                        </div>


                                        <div className="location-cp">

                                            <div className="form-floating mb-3-inscription">

                                                <GenericInput
                                                    required={selectedOption === "option3"}
                                                    name="alternativeAddressCity"
                                                    register={register}
                                                    errors={errors}
                                                    label="Localidad"
                                                    placeholder="Localidad"
                                                />

                                            </div>

                                            <div className="form-floating mb-3-inscription">

                                                <GenericInput
                                                    required={selectedOption === "option3"}
                                                    name="alternativeAddressZipCode"
                                                    register={register}
                                                    errors={errors}
                                                    label="Código Postal"
                                                    placeholder="Código Postal"
                                                />
                                            </div>

                                        </div>

                                        <div className="form-floating mb-3-inscription">

                                            <GenericInput
                                                required={selectedOption === "option3"}
                                                name="alternativeAddressProvince"
                                                register={register}
                                                errors={errors}
                                                label="Provincia"
                                                placeholder="Provincia"
                                            />

                                        </div>
                                    </div>
                                    : null}
                            </> : null}






                            <div className="container mt-5 container-mt-5 container-mw">

                                <span className="address-title">Profesiones</span>

                                <div className="mb-3 mb3-class-profession select-container ">

                                    <span className="span-profesion-i">Profesión</span>

                                    <GenericSelect
                                        name={'professionId'}
                                        placeholder={'Tipo de Documento'}
                                        values={formatDataforGenericSelect(professionsData)}
                                        onSelectChange={handleSelectChange}
                                        preValue={formatDataforGenericSelect(newArray.length > 0 ? newArray : [])}
                                        prop={'description'}
                                        setValue={setValue}
                                        {...register('professionId', { required: true })}
                                    />

                                </div>

                                <div className="form-floating mb-3">

                                    <GenericInput
                                        required={false}
                                        name="professionalLicense"
                                        register={register}
                                        errors={errors}
                                        label="Matrícula Profesional"
                                        placeholder="Matrícula Profesional"
                                    />

                                </div>

                            </div>



                            {sendKit ?
                                <div className="form-floating mb-3">
                                    <span className="span-how">Cómo te enteraste de TPA®? ¿Qué te llevo a tomar la decisión de ser parte?</span>
                                    {/* <textarea
                            style={{ height: "100%" }}
                            className="form-control form-control-textTarea"
                        ></textarea> */}


                                    <textarea
                                        style={{ height: "100%" }}
                                        id="floatingTextArea"
                                        placeholder="Escribe tu mensaje aquí..."
                                        name='howMet'
                                        className={`form-control form-control-textTarea ${errors.howMet ? 'inError' : ''}`}
                                        {...register('howMet', { required: 'Campo requerido' })}

                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        maxLength={200}
                                    />

                                    {/* <p className='textarea-length'>{text.length} / 200</p> */}
                                    {text.length > 0 ? <p className='textarea-length'>{text.length} / 200</p> : null}

                                    {errors.howMet &&

                                        <span className='invalid-feedback d-flex field-validation-error'>
                                            <span className="error-message">{errors.howMet.message}</span>
                                        </span>
                                    }
                                    {/* <label class="label-textInput label-floating" for="textInput">Cómo te enteraste de TPA®? ¿Qué te llevo a tomar la decisión de ser parte?</label> */}
                                </div>

                                : null}


                            <div className="submit-button">

                                <input type="submit" className="button-send" value="Enviar" />
                                {/* <small className="form-text text-muted small-cancelar"><Link to="">Cancelar</Link></small> */}

                            </div>


                        </form>
                    </div>

                    :
                    <FormErrorMessage

                        title='Formulario de Inscripción'
                        text='Ya recibimos tu solicitud. Pronto nos contactaremos.'

                    />
            }



        </main>
    )
}
